import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {Link} from "react-router-dom";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {AdminCrudList} from "Views/Shared/Crud/AdminCrudList";
import {getConfigList} from "Api/Query/ConfigQuery";
import {AdminConfigValuePreview} from "Views/Config/AdminConfigValuePreview";

export const AdminConfigList: React.FC = () => {

    const [refresh, setRefresh] = useState<boolean>(false)
    const headers: string[] = ['CLAVE', 'VALOR', '']

    return (
        <RequireAuth>
            <AdminCrudList
                canSelectMultipleRows={false}
                title={"Config"}
                headers={headers}
                queryMethod={getConfigList}
                queryName={"adminConfigList"}
                pageSize={50}
                customFilters={<></>}
                refreshSwitch={refresh}
                tableRow={(item: any, key: number) =>
                    <>
                        <td>
                            <Link to={ROUTE_PATHS.ADMIN_CONFIG_EDIT.replace(":id", item.id)}>
                                {item.id}
                            </Link>
                        </td>
                        <td>
                            <AdminConfigValuePreview
                                entity={item}
                                imgWidth={200}
                            />
                        </td>
                        <td className={"text-center align-middle"}>
                            <Button
                                className={"purple-btn btn-sm"}
                                href={ROUTE_PATHS.ADMIN_CONFIG_EDIT.replace(":id", item.id)}
                            >
                                Modificar
                            </Button>
                        </td>
                    </>
                }
                deleteMethod={() => {}}
            />
        </RequireAuth>
    )
}
